window.hideAllTooltips = () => {
    $('[role="tooltip"]').tooltip('hide');
}
